import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { WorkspaceUserData } from "../../../types";
import { useWorkspaceUsersTableAgGridOptions } from "./hooks";

export type WorkspaceUserTableProps = {
  onGridReady: (event: AgGrid.GridReadyEvent<WorkspaceUserData>) => void;
  rowData: WorkspaceUserData[];
  onRemoveUser: (user: WorkspaceUserData | null) => void;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
};

export const WorkspaceUserTable = ({
  rowData,
  onGridReady,
  onRemoveUser,
  onFilterChanged,
}: WorkspaceUserTableProps) => {
  const { colDefs } = useWorkspaceUsersTableAgGridOptions({ onRemoveUser });
  const { gridOptions } = useAgGridDefaults({
    overrides: {
      pagination: true,
      paginationPageSizeSelector: true,
      paginationPageSize: 20,
      overlayNoRowsTemplate: "No users assigned to this workspace",
      rowSelection: "multiple",
    },
  });

  return (
    <Grid
      onGridReady={onGridReady}
      columnDefs={colDefs}
      rowData={rowData}
      gridOptions={gridOptions}
      onFilterChanged={onFilterChanged}
    />
  );
};
